import { useEffect } from "react";
import { useFormContext } from "react-hook-form";

import { FormDataModel } from "helpers/global-types";
import { mapCartToForm } from "helpers/mapCartToForm";
import type { Cart } from "store/types";

type Props = {
  cart?: Cart | null;
  formData?: FormDataModel;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  defaults?: any;
  keepErrors?: boolean;
};

export const useResetForm = ({ defaults, cart, keepErrors }: Props) => {
  const { reset } = useFormContext<FormDataModel>();

  const formData = cart ? mapCartToForm(cart) : ({} as Partial<FormDataModel>);

  useEffect(() => {
    const currentStepData = Object.keys(defaults ?? []).reduce((acc, key) => {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      //@ts-ignore
      acc[key] = formData[key] ?? defaults[key];
      return acc;
    }, {});
    reset(currentStepData, { keepErrors: keepErrors });
  }, [defaults]);
};
